import React from "react"
import Row from "react-bootstrap/Row"

import ContentBox from "@atoms/ContentBox/ContentBox"
import Image from "@atoms/Image/Image"
import Placeholder from "@atoms/Placeholder/Placeholder"

import styles from "./ServiceDescriptionListItem.module.scss"

const ServiceDescriptionListItem = ({ image, icon, title, content }) => {
  return (
    <div className={styles.item}>
      <Row className="mobile-bottom-margins-xs">
        <div className="col-md-3 col-lg-4">
          <div className="make-full-width-on-mobile">
            <div className={styles.image}>
              {image ? (
                <Image image={image} widths={[260, 480, 720]} alt="" />
              ) : (
                <Placeholder aspectRatio="1:1" />
              )}
            </div>
          </div>
        </div>
        <div className="col-md-9 col-lg-8">
          <div className={`${styles.heading} base-margin-bottom-xxs`}>
            {icon && (
              <img
                className={styles.icon}
                role="img"
                src={`/media/svg/${icon}.svg`}
                alt=""
              />
            )}
            {title && <h2>{title}</h2>}
          </div>
          <div className={styles.content}>
            <ContentBox html={content} emphasis={false} />
          </div>
        </div>
      </Row>
    </div>
  )
}
export default ServiceDescriptionListItem
